import React, { useEffect, useRef, useState } from "react";
import { FaCheckCircle, FaExternalLinkAlt, FaMicrophone, FaPen, FaPlus, FaRegImage, FaSave, FaStop, FaTrash } from "react-icons/fa";
import axios from "axios";
import { BACKEND } from "../../config/configEnvs";
import { toast } from "react-toastify";
import Tooltip from "../ui/ToolTip";
import moment from "moment-timezone";
import { MdOutlineCloudUpload } from "react-icons/md";
import SubirArchivoPagoCotizacionDialog from "../dialogs/SubirArchivoPagoCotizacionDialog";
import VerPagoCotizacionDialog from "../dialogs/VerPagoCotizacionDialog";
import ModalInDrawer from "../ui/ModalInDrawer";
import { useSelector } from "react-redux";
import DeleteButton from "../ui/components/DeleteButton";
import IdButton from "../ui/components/IdButton";
import CopyToClipBoard from "../../utils/CopyToClipBoard";
import ActualizarHistorialPagosCotizaciones from "../../utils/automateFuncions/ActualizarHistorialPagosCotizaciones";
import NormalizeText from "../../utils/normalizeValues/NormalizeText";
import SubirArchivoCompraDominioDialog from "../dialogs/SubirArchivoCompraDominio";
import DinamicBoxButton from "../ui/components/DinamicBoxButton";

const ItemRowPagoCotizacion = ({ data, moneda, totalPrice, setPagosList, pagosList, serviciosList, isAdmin, currencyExchange, currency, hostingDomainCot }) => {

  const user = useSelector((state) => state.auth.user)

  //// EVitar la modificación de la cuenta en otros pagos ////

  const [disableBAselectors, setDisableBAselectors] = useState(false)

  const VerifyFirstPayment = () => {
    const firstPayment = pagosList.find((pago) => pago.id === pagosList[0].id)

    const firstPaymentBank = firstPayment ? firstPayment.banco : null
    const firstPaymentAccount = firstPayment ? firstPayment.cuenta : null

    if (firstPaymentBank && firstPaymentAccount) {
      setDisableBAselectors(true)
    }

    return { firstPaymentBank, firstPaymentAccount }
  }

  useEffect(() => {
    const { firstPaymentBank, firstPaymentAccount } = VerifyFirstPayment()
    setRowValues((prev) => ({ ...prev, banco: firstPaymentBank, cuenta: firstPaymentAccount }))
  }, [pagosList])

///////////////////////////////////////////////////////////////

  const [updatedDataText, setUpdatedDataText] = useState("Datos actualizados: \n")
  
  const lockStatus = data?.cotizacion?.estado === "Exito" && isAdmin;

  const [rowValues, setRowValues] = useState({
    cotizacion: null,
    descripcion: "",
    percentage: 0,
    precio: 0,
    banco: "",
    cuenta: "",
    notas: "",
    audios: [],
    tipoDescuento: "",
    montoDescuento: 0,
    montosServicios: [],
    pagoVerificado: false,
    faltaCompromisoPago: false,
    fechaLimite: {
      startDate: null,
      endDate: null,
    },
    fechaPago: {
      startDate: null,
      endDate: null
    },
    pagado: false,
    imagen: null,
    compraHd: false,
    imagenCompraHd: false,
  });

  //console.log(rowValues.pagoVerificado)

  const [isSuccess, setIsSuccess] = useState(false);
  const [uploadImage, setUploadImage] = useState({ title: "", open: false });
  const [verImagen, setVerImagen] = useState({ imagen: null, open: false });
  const [verImagenCompraHd, setVerImagenCompraHd] = useState({ imagen: null, open: false });
  const [uploadImageCompraHd, setUploadImageCompraHd] = useState({ title: "", open: false });

  const [modalStatus, setModalStatus] = useState(false)

  // Manejador para agregar un nuevo servicio y monto.
  const addServicio = () => {
    const newServicio = { servicioId: "", monto: 0, igv: "no" };
    const updatedMontos = [...rowValues.montosServicios, newServicio];
    
    // Calcular el precio total como la suma de los montos más IGV cuando corresponda
    const precioTotal = updatedMontos.reduce((sum, servicio) => {
      const montoBase = Number(servicio.monto);
      const montoIGV = servicio.igv === "si" ? montoBase * 0.18 : 0;
      return sum + montoBase + montoIGV;
    }, 0);
    
    setRowValues((prev) => ({
      ...prev,
      montosServicios: updatedMontos,
      precio: precioTotal,
      percentage: (precioTotal / totalPrice) * 100
    }));
  };

  // Manejador para actualizar el servicio seleccionado.
  const updateServicio = (index, servicioId) => {
    const updatedMontos = [...rowValues.montosServicios];
    
    // Buscar el servicio en la lista de servicios
    const servicioSeleccionado = serviciosList.find((s) => s.id === servicioId);
    
    if (servicioSeleccionado) {
      // Actualizamos el servicio seleccionado y el IGV según el servicio
      updatedMontos[index] = {
        ...updatedMontos[index],
        servicioId: { id: servicioId },
        igv: servicioSeleccionado.igv || "no", // Asumiendo que `igv` es parte de cada servicio
      };
    } else {
      updatedMontos[index].servicioId = { id: servicioId };
      updatedMontos[index].igv = "no"; // Si no se selecciona un servicio, el IGV es "no"
    }
    
    // Calcular el precio total como la suma de los montos más IGV cuando corresponda
    const precioTotal = updatedMontos.reduce((sum, servicio) => {
      const montoBase = Number(servicio.monto);
      const montoIGV = servicio.igv === "si" ? montoBase * 0.18 : 0;
      return sum + montoBase + montoIGV;
    }, 0);

    setUpdatedDataText((prev) => prev + `Montos servicios actualizado, servicio añadido: ${servicioSeleccionado?.servicio?.name}.\n`)
    
    setRowValues((prev) => ({
      ...prev,
      montosServicios: updatedMontos,
      precio: precioTotal,
      percentage: (precioTotal / totalPrice) * 100
    }));
  };
  
  // Manejador para actualizar el monto del servicio.
  const updateMonto = (index, monto) => {
    const updatedMontos = [...rowValues.montosServicios];
    updatedMontos[index].monto = Number(monto);
    
    // Calcular el precio total como la suma de los montos más IGV cuando corresponda
    const precioTotal = updatedMontos.reduce((sum, servicio) => {
      const montoBase = Number(servicio.monto);
      const montoIGV = servicio.igv === "si" ? montoBase * 0.18 : 0;
      return sum + montoBase + montoIGV;
    }, 0);

    setUpdatedDataText((prev) => prev + `Monto actualizado: ${precioTotal}.\n`)

    setRowValues((prev) => ({
      ...prev,
      montosServicios: updatedMontos,
      precio: precioTotal,
      percentage: (precioTotal / totalPrice) * 100
    }));
  };

  useEffect(() => {
    if (data) {
      if (data.cotizacion) setRowValues((prev) => ({ ...prev, cotizacion: data.cotizacion.id }))
      if (data.descripcion) setRowValues((prev) => ({ ...prev, descripcion: data.descripcion }))
      if (data.percentage) setRowValues((prev) => ({ ...prev, percentage: data.percentage }))
      if (data.precio) setRowValues((prev) => ({ ...prev, precio: data.precio }))
      if (data.pagado) setRowValues((prev) => ({ ...prev, pagado: true }))
      if (data.imagen) setRowValues((prev) => ({ ...prev, imagen: data.imagen }))
      if (data.pagoVerificado) setRowValues((prev) => ({ ...prev, pagoVerificado: data.pagoVerificado }))
      if (data.faltaCompromisoPago) setRowValues((prev) => ({ ...prev, faltaCompromisoPago: data.faltaCompromisoPago }))
      if (data.montosServicios) setRowValues((prev) => ({ ...prev, montosServicios: data.montosServicios }))
      if (data.compraHd) setRowValues((prev) => ({ ...prev, compraHd: data.compraHd }))
      if (data.compraHosting) setRowValues((prev) => ({ ...prev, compraHosting: data.compraHosting }))
      if (data.imagenCompraHd) setRowValues((prev) => ({ ...prev, imagenCompraHd: data.imagenCompraHd }))
      if (data.banco) setRowValues((prev) => ({ ...prev, banco: data.banco }))
      if (data.cuenta) setRowValues((prev) => ({ ...prev, cuenta: data.cuenta }))
      if (data.notas) setRowValues((prev) => ({ ...prev, notas: data.notas }))
      if (data.tipoDescuento) setRowValues((prev) => ({ ...prev, tipoDescuento: data.tipoDescuento }))
      if (data.montoDescuento) setRowValues((prev) => ({ ...prev, montoDescuento: data.montoDescuento }))
      if (data.audios) setRowValues((prev) => ({ ...prev, audios: data.audios }))
      if (data.fechaLimite)
        console.log("¿Que miras?")
        setRowValues((prev) => ({
          ...prev,
          fechaLimite: {
            startDate: moment.utc(data.fechaLimite).format("YYYY-MM-DD"),
            endDate: moment.utc(data.fechaLimite).format("YYYY-MM-DD"),
          },
        }))
      if (data.fechaPago)
        setRowValues((prev) => ({
          ...prev,
          fechaPago: {
            startDate: moment.utc(data.fechaPago).format("YYYY-MM-DD"),
            endDate: moment.utc(data.fechaPago).format("YYYY-MM-DD"),
          },
        }))
    }
  }, [data, totalPrice])

  const saveItem = async () => {
    try {

      const today = new Date().toISOString();

      // console.log("Guardando pago...")

      if (data.id === pagosList[0].id && rowValues.pagado) {
        // console.log('=== INICIO DEL BLOQUE DE ACTUALIZACIÓN ===');
        // console.log('Fecha actual:', today);
        // console.log('ID de la cotización:', data.cotizacion.id);
        // console.log('Fecha de venta actual:', data?.cotizacion?.fechaVenta);
        // console.log('¿Se actualizará fecha de venta?:', !data?.cotizacion?.fechaVenta);
        
        // console.log('Servicios a procesar:', serviciosList.length);
        // console.log('Servicios sin fecha de ingreso:', serviciosList.filter(service => !service.fechaIngreso).length);
        
        await Promise.all([
          // Solo actualiza fechaVenta si no existe
          !data?.cotizacion?.fechaVenta && 
            axios.put(`${BACKEND}/api/cotizaciones/${data.cotizacion.id}`, {
              fechaVenta: today
            }).then(() => console.log('✅ Fecha de venta actualizada')),
          // Actualiza fechaIngreso solo para servicios que no la tienen
          ...serviciosList
            .filter(service => !service.fechaIngreso)
            .map(service => 
              axios.put(`${BACKEND}/api/serviciosCotizaciones/${service.id}`, {
                fechaIngreso: today
              }).then(() => console.log(`✅ Fecha de ingreso actualizada para servicio: ${service.id}`))
            )
        ].filter(Boolean));
        
        // console.log('=== FIN DEL BLOQUE DE ACTUALIZACIÓN ===');
      }

      let audiosIds = []

      // Filtrar audios que no tienen la propiedad `id`
      const audiosToUpload = rowValues.audios.filter((file) => !file.id);
  
      if (audiosToUpload.length > 0) {
        for (const file of audiosToUpload) {
          const audioId = await uploadAudio(file);
          audiosIds.push(audioId);
        }
      }

      // Obtener los IDs de los audios que ya existen
      const existingAudioIds = rowValues.audios
      .filter((file) => file.id)
      .map((file) => file.id);

      // Combinar los IDs de los audios existentes con los nuevos
      audiosIds = [...existingAudioIds, ...audiosIds];

      // Transformar montosServicios
      const transformedMontosServicios = rowValues.montosServicios.map((item) => ({
        servicioId: typeof item.servicioId === "object" ? item.servicioId?.id : item.servicioId,
        monto: item.monto,
        igv: item.igv
      }));
  
      // Realizar la solicitud PUT
      const response = await axios.put(`${BACKEND}/api/pagosCotizaciones/${data.id}`, {
        descripcion: rowValues.descripcion,
        percentage: rowValues.percentage,
        precio: rowValues.precio,
        fechaLimite: rowValues.fechaLimite.startDate,
        banco: rowValues.banco,
        cuenta: rowValues.cuenta,
        fechaPago: rowValues.fechaPago.startDate,
        montosServicios: transformedMontosServicios,
        notas: rowValues.notas,
        pagado: rowValues.pagado,
        audios: audiosIds,
        pagoVerificado: rowValues.pagoVerificado,
        faltaCompromisoPago: rowValues.faltaCompromisoPago,
        tipoDescuento: rowValues.tipoDescuento,
        montoDescuento: rowValues.montoDescuento,
        compraHd: rowValues.compraHd,
        compraHosting: rowValues.compraHosting
      });

      ActualizarHistorialPagosCotizaciones({
        idCotizacion: data.cotizacion.id,
        idPago: data.id,
        tipoEvento: "Pago actualizado",
        idUsuario: user.id,
        detalles: updatedDataText === "Datos actualizados: " ? "No se han realizado cambios" : updatedDataText
      })
  
      // Actualizar cotización localmente
      updateCotizacionLocally(response.data.doc);
  
      // Mostrar mensaje de éxito
      setIsSuccess(true);
      setTimeout(() => setIsSuccess(false), 2000);
    } catch (e) {
      return null
    }
  };

  const updateCotizacionLocally = (updatedPago) => {
    setPagosList((prevCotList) => {
      return prevCotList.map((cot) => {
        if (cot.id === updatedPago.id) {
          return { ...cot, ...updatedPago };
        } else {
          return cot;
        }
      });
    });
  };

  const deleteItem = async () => {
    if (!window.confirm("¿Estás seguro de que quieres eliminar este pago?")) return;

    try {
      const deletedItem = await axios.delete(`${BACKEND}/api/pagosCotizaciones/${data.id}`)
      setPagosList(pagosList.filter((ev) => ev.id !== deletedItem.data.id));
      ActualizarHistorialPagosCotizaciones({
        idCotizacion: data.cotizacion.id,
        idPago: data.id,
        tipoEvento: "Pago eliminado",
        idUsuario: user.id,
        detalles: "Pago eliminado manualmente"
      })

      toast.success("Pago eliminado correctamente")
    } catch (error) {
      toast.error("Error al eliminar el pago")
    }
  }

  const [toolTipImageActive, setToolTipImageActive] = useState(false);
  const [toolTipImageCompraHdActive, setToolTipImageCompraHdActive] = useState(false);

  // Audios
    
  const [isRecording, setIsRecording] = useState(false)

  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  const uploadAudio = async (file) => { // Subir audio
    try {
      const formData = new FormData()

      formData.append("file", file)

      const response = await axios.post(`${BACKEND}/api/audiosPagos`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      })

      return response.data.doc.id

    } catch (error) {
      toast.error("Error subiendo el audio")
    }
  }

  const generateFileName = () => { // Generar nombre del audio
    return `audio_${new Date().getTime()}.wav`;
  };

  const startRecording = () => { // Empezar a grabar
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ audio: true })
        .then((stream) => {
          const mediaRecorder = new MediaRecorder(stream);
          mediaRecorderRef.current = mediaRecorder;
          mediaRecorder.start();
    
          setIsRecording(true);  // Cambia el estado para indicar que está grabando
  
          mediaRecorder.ondataavailable = (event) => {
              audioChunksRef.current.push(event.data);
          };
    
          mediaRecorder.onstop = async () => {
            const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/wav' });
            const fileName = generateFileName();
              
            const audioFile = new File([audioBlob], fileName, { type: 'audio/wav' });
            const audioUrl = URL.createObjectURL(audioBlob);
            setIsRecording(false);
  
            if (audioFile.size <= 5000000 && rowValues.audios.length < 5) {
              setRowValues(prevValues => ({
                ...prevValues,
                audios: [...prevValues.audios, audioFile]
              }))

            } else {
              toast.warning('El archivo de audio excede el tamaño máximo de 5MB o se alcanzó el límite de 5 archivos.');
            }
  
            audioChunksRef.current = [];
          };
        })
        .catch((error) => {
          toast.error('Error: ' + error);
        });
    } else {
      toast.error('Tu navegador no soporta la grabación de audio.');
    }
  };

  const stopRecording = () => { // Detener la graación
    if (mediaRecorderRef.current) {
        mediaRecorderRef.current.stop();  // Detiene la grabación
        setIsRecording(false);  // Cambia el estado para indicar que se dejó de grabar
    }
  };

  const deleteAudio = (indexToDelete) => { // Eliminar un audio
    setRowValues((prevValues) => ({
      ...prevValues,
      audios: prevValues.audios.filter((_, index) => index !== indexToDelete)
    }))
  }

  return (
    <>
      <ModalInDrawer
        activeModal={modalStatus}
        onClose={() => setModalStatus(false)}
        title="Notas del pago"
        centered
      >
        <div className="flex flex-col gap-6 text-xs">

          <div className="audios border border-gray-300 rounded-md p-4">
            <label className="block text-gray-700 mb-4" htmlFor="audiosAdmin">
              Notas
            </label>
            <textarea
              className="text-xs rounded-lg w-full"
              rows="5"
              value={rowValues.notas}
              placeholder="Notas del pago"
              onChange={(e) =>
                setRowValues((prev) => ({
                  ...prev,
                  notas: e.target.value,
                }))
              }
            />
          </div>

          <div className="audios border border-gray-300 rounded-md p-4">
            <label className="block text-gray-700 mb-4" htmlFor="audiosAdmin">
              Audios
            </label>
            <div className="flex flex-col w-full">

              {rowValues.audios?.length > 0 ? (
                <ul className="list-disc">
                  {rowValues.audios.map((fileObj, index) => {
                    const url = fileObj.url ? fileObj.url : URL.createObjectURL(fileObj)
                    const type = fileObj.mimeType ? fileObj.mimeType : fileObj.type
                    const name = fileObj.filename ? fileObj.filename : fileObj.name

                    const fileType = type.split('/')[0];
                    const mimeType = type
                    
                    return (
                      <div key={index} className="mb-8 px-4">

                        {fileType === 'audio' && (
                          <div className="space-y-4 bg-gray-50 border border-gray-200 rounded-md p-4 shadow-sm">
                            <div className="flex items-center justify-between border-b border-gray-200 pb-2 mb-2">
                              <span className="font-semibold text-gray-800">{name}</span>
                              <div className="flex space-x-2">
                                <button
                                  type="button"
                                  onClick={() => window.open(url, '_blank')}
                                  className="p-2 text-blue-500 hover:bg-blue-600 hover:bg-opacity-20 rounded-md transition duration-150"
                                  title="Abrir en una nueva pestaña"
                                >
                                  <FaExternalLinkAlt />
                                </button>
                                <button
                                  type="button"
                                  onClick={() => deleteAudio(index)}
                                  className="p-2 text-red-500 hover:bg-red-600 hover:bg-opacity-20 rounded-md transition duration-150"
                                  title="Eliminar audio"
                                >
                                  <FaTrash />
                                </button>
                              </div>
                            </div>
                            <audio controls className="w-full rounded-md bg-gray-100">
                              <source src={url} type={mimeType || 'audio/mpeg'} />
                              Tu navegador no soporta el elemento de audio.
                            </audio>
                          </div>
                        
                        )}

                      </div>
                    );
                  })}
                </ul>
              ) : (
                <div className="flex justify-center items-center h-[50px] border rounded-md mb-4">
                  No hay archivos subidos
                </div>
              )}

            </div>

            <div className="newLinks">
              {rowValues.audios?.length < 5 ? (
                !isRecording ? (
                  <button
                    onClick={startRecording}  // Función para subir un nuevo link
                    className="flex w-full justify-center items-center gap-2 bg-white hover:bg-green-200 transition-all duration-100 text-white px-4 py-2 rounded-lg"
                  >
                    <span className="text-green-700">Grabar nuevo audio</span>
                    <FaMicrophone className="text-green-700"/>
                  </button>
                ) : (
                  <button
                    onClick={stopRecording}  // Función para subir un nuevo link
                    className="flex w-full justify-center items-center gap-2 bg-white hover:bg-red-200 transition-all duration-100 text-white px-4 py-2 rounded-lg"
                  >
                    <span className="text-red-700">Detener grabación</span>
                    <FaStop className="text-red-700"/>
                  </button>
                )

              ) : (
                <div className="flex w-full justify-center items-center">
                  Ya has subido el máximo de 5 audios
                </div>
              )
            }
            </div>

          </div>
        </div>
      </ModalInDrawer>

      {/* Valores de la fila */}
      <tr className="bg-white border-b">
        
        {/* Eliminar */}
        {isAdmin && (
          <th scope="row" className="px-6 py-4">
            <DeleteButton
              action={deleteItem}
              disabled={rowValues.pagado && !isAdmin}
              content={"Eliminar pago"}
            />
          </th>
        )}

        {/* Guardar */}
        <td className="px-6 py-4 sticky left-0 z-[5] bg-white min-w-[60px] w-[60px]">
          <div className=" flex justify-start items-center gap-2">
            {isSuccess ? (
              <div className=" inline-flex gap-2  items-center">
                <FaCheckCircle className=" text-green-500" />
                <span className="text-xs text-green-500">Guardado</span>
              </div>
            ) : (
              <DinamicBoxButton
                action={saveItem}
                content="Guardar"
                icon={<FaSave className="text-[10px]" />}
                color="blue"
              />
            )}
          </div>
        </td>

        {/* Id */}
        <th className="px-6 py-4 font-medium whitespace-nowrap text-black">
          <IdButton
            content={data.id}
            action={() => CopyToClipBoard(data.id)}
          />
        </th>
        
        {/* Moneda */}
        <th className="px-6 py-4 font-medium whitespace-nowrap text-black">
          {moneda}
        </th>

        {/* N° de pago */}
        <td className="px-6 py-4 sticky bg-white z-[5] left-[60px] min-w-[100px] w-[100px]">
          <input 
            type="text" 
            value={rowValues.descripcion || ""} 
            onChange={(e) => setRowValues((prev) => ({ ...prev, descripcion: e.target.value }))} 
            disabled={rowValues.pagado && !isAdmin} 
            className="w-full bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2 disabled:bg-gray-100 disabled:cursor-not-allowed"
          />
        </td>

        {/* Distribución por servicio */}
        <td className="px-6 py-4 font-medium whitespace-nowrap text-black sticky z-[5] bg-white left-[160px]" style={{ minWidth: '500px', width: '500px' }}>

          <div className="flex flex-col items-center justify-center">

            {rowValues.montosServicios && rowValues.montosServicios?.length > 0 && (
               <div className="flex gap-2 items-center justify-center mb-2 font-bold">
                <span className={`px-2 py-1 border text-black border-gray-300 focus:outline-none rounded-md w-[130px] text-xs`}>
                  Servicio
                </span>
                <span className={`px-1 py-1 border text-black border-gray-300 focus:outline-none rounded-md w-[90px] text-xs`}>
                  Monto
                </span>
                <span className={`px-2 py-1 border text-black border-gray-300 focus:outline-none rounded-md w-[40px] text-xs`}>
                  IGV
                </span>
                <span className={`px-2 py-1 truncate border text-black border-gray-300 focus:outline-none rounded-md w-[100px] text-xs`}>
                  Monto IGV
                </span>
                <span className={`px-2 py-1 w-[40px]`}>
                </span>
              </div>
            )} 

            {rowValues.montosServicios.map((servicio, index) => (
              <div key={index} className="flex gap-2 items-center justify-center mb-2">
              
                <select
                  value={typeof servicio.servicioId === "object" ? servicio?.servicioId?.id : servicio.servicioId}
                  onChange={(e) => updateServicio(index, e.target.value)}
                  disabled={rowValues.pagado && !isAdmin}
                  className={`px-2 py-1 border border-gray-300 focus:outline-none w-[130px] rounded-md text-xs`}
                >
                  <option value="">Seleccionar servicio</option>
                  {serviciosList.map((servicioOption) => (
                    <option key={servicioOption.id} value={servicioOption.id}>
                      {servicioOption.servicio.name}
                    </option>
                  ))}
                </select>
            
                <input
                  type="number"
                  value={servicio.monto}
                  disabled={rowValues.pagado && !isAdmin}
                  onChange={(e) => updateMonto(index, e.target.value)}
                  className={`px-2 py-1 border border-gray-300 focus:outline-none rounded-md w-[90px] text-xs`}
                  placeholder="Monto"
                  min={0}
                />

                <span 
                  className={`px-2 py-1 border border-gray-300 focus:outline-none rounded-md w-[40px] text-xs`}
                >
                  {servicio.igv === "si" ? "Sí" : "No"}
                </span>
                
                <span 
                  className={`px-2 py-1 border border-gray-300 focus:outline-none rounded-md w-[100px] text-xs`}
                >
                  {servicio.igv === "si" ? (servicio.monto * 0.18).toFixed(2) : (0)}
                </span>

                <button
                  disabled={rowValues.pagado && !isAdmin}
                  onClick={() => {
                    const updatedMontos = [...rowValues.montosServicios];
                    updatedMontos.splice(index, 1);
                    
                    // Calcular el precio total como la suma de los montos más IGV cuando corresponda
                    const precioTotal = updatedMontos.reduce((sum, servicio) => {
                      const montoBase = Number(servicio.monto);
                      const montoIGV = servicio.igv === "si" ? montoBase * 0.18 : 0;
                      return sum + montoBase + montoIGV;
                    }, 0);
                    
                    setRowValues((prev) => ({
                      ...prev,
                      montosServicios: updatedMontos,
                      precio: precioTotal,
                      percentage: (precioTotal / totalPrice) * 100
                    }));
                  }}
                  className="text-red-600 p-2 hover:text-red-800 w-[40px]"
                >
                  <FaTrash />
                </button>
                  
              </div>
            ))}

            {rowValues.montosServicios?.length < serviciosList?.length && (
              <div className="w-full flex items-center justify-center w-[434px]"> 
                <button
                  onClick={addServicio}
                  disabled={rowValues.pagado && !isAdmin}
                  className="flex flex-row text-xs font-bold items-center truncate justify-center gap-2 px-12 py-1 bg-green-500 text-white rounded-full hover:bg-green-600"
                >
                  Vincular servicio
                  <FaPlus />
                </button>
              </div>
            )}

          </div>
        </td>

        {/* Precio total */}
        <td className="px-6 py-4 sticky z-[5] bg-white left-[660px]" style={{ minWidth: '150px', width: '150px' }}>
          <input
            id={"precio"}
            type="number"
            value={parseFloat(rowValues.precio.toFixed(2))}
            min={0}
            disabled={true}
            className="w-full bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2 disabled:bg-gray-100 disabled:cursor-not-allowed"
          />
        </td>

        {/* Monto al tipo de cambio */}
        {NormalizeText(data?.cotizacion?.cliente?.pais || data?.cotizacion?.lead?.country) !== NormalizeText("Perú") && (
          <td className="px-6 py-4">
            <span className="whitespace-nowrap">{(rowValues.precio/currencyExchange).toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + currency}</span>
          </td>
        )}
        
        {/* Porcentaje */}
        <td className="px-6 py-4">
          <span>{((rowValues.precio / totalPrice) * 100).toFixed(2)}  %</span>
        </td>
        
        {/* Fecha límite */}
        <td className="px-6 py-4 ">
          <div className=" ">
            <input 
              type="date"
              placeholder="Fecha límite"
              value={rowValues.fechaLimite?.startDate || ''}
              className="py-2 px-4 border border-gray-300 focus:outline-none rounded-md text-xs w-[150px]"
              disabled={(rowValues.pagado && !isAdmin && rowValues.fechaLimite?.startDate && rowValues.fechaLimite?.startDate !== "Fecha inválida")}
              onChange={(e) => {
                if (rowValues.pagado) {
                  const confirmChange = window.confirm(`¿Estás seguro de cambiar la fecha límite a ${e.target.value}? Una vez establecida, no podrás cambiar la fecha si está como pagado`);
                  if (!confirmChange) return;
                }
                setUpdatedDataText((prev) => prev + `Fecha límite actualizada: ${e.target.value}.\n`)
                setRowValues((prev) => ({
                  ...prev,
                  fechaLimite: {
                    ...prev.fechaLimite,
                    startDate: e.target.value,
                    endDate: e.target.value,
                  },
                }));
              }}
            />
          </div>
        </td>
        
        {/* Fecha de pago */}
        <td className="px-6 py-4 ">
          <div className=" ">
            <input 
              type="date"
              placeholder="Fecha de pago"
              value={rowValues.fechaPago?.startDate || ''}
              className="py-2 px-4 border border-gray-300 focus:outline-none rounded-md text-xs w-[150px]"
              disabled
              onChange={(e) => {
                if (rowValues.pagado) {
                  const confirmChange = window.confirm(`¿Estás seguro de cambiar la fecha de pago a ${e.target.value}? Una vez establecida, no podrás cambiar la fecha si está como pagado`);
                  if (!confirmChange) return;
                }
                setUpdatedDataText((prev) => prev + `Fecha de pago actualizada: ${e.target.value}.\n`)
                setRowValues((prev) => ({
                  ...prev,
                  fechaPago: {
                    ...prev.fechaPago, 
                    startDate: e.target.value,
                    endDate: e.target.value,
                  },
                }));
              }}
            />
          </div>
        </td>
        
        {/* Banco */}
        <td className="px-6 py-4 ">
          <div className=" ">
            <select 
              value={rowValues.banco}
              className="py-2 px-4 border border-gray-300 focus:outline-none rounded-md text-xs w-[100px]"
              disabled={rowValues.pagado && !isAdmin}
              onChange={(e) => {
                setUpdatedDataText((prev) => prev + `Banco actualizado: ${e.target.value}.\n`)
                setRowValues((prev) => ({
                  ...prev,
                  banco: e.target.value
                }))
              }}
            >
              <option value="Seleccionar">Seleccionar</option>
              <option value="BCP">BCP</option>
              <option value="BCP (dólares)">BCP (dólares)</option>
              <option value="Interbank">Interbank</option>
              <option value="Scotiabank">Scotiabank</option>
            </select>
          </div>
        </td>

        {/* Cuenta */}
        <td className="px-6 py-4 ">
          <div className=" ">
            <select 
              value={rowValues.cuenta}
              className="py-2 px-4 border border-gray-300 focus:outline-none rounded-md text-xs w-[100px]"
              disabled={rowValues.pagado && !isAdmin}
              onChange={(e) => {
                setUpdatedDataText((prev) => prev + `Cuenta actualizada: ${e.target.value}.\n`)
                setRowValues((prev) => ({
                  ...prev,
                  cuenta: e.target.value
                }))
              }}
            >
              <option value="Seleccionar">Seleccionar</option>
              {rowValues.banco === "BCP" && (
                <>
                  <option value="Eduardo - Cta. 19195069993093 - CCI 00219119506999309354">Eduardo - Cta. 19195069993093 - CCI 00219119506999309354</option>
                  <option value="Yessica - Cta. 19102800857047 - CCI 00219110280085704755">Yessica - Cta. 19102800857047 - CCI 00219110280085704755</option>
                  <option value="Soluciones Digitales BTL 360 - Cta. 1927226709058 - CCI 00219200722670905836">Soluciones Digitales BTL 360 - Cta. 1927226709058 - CCI 00219200722670905836</option>
                </>
              )}

              {rowValues.banco === "BCP (dólares)" && (
                <option value="Eduardo (dólares) - Cta. 19208571382160 - CCI 00219210857138216031">Eduardo (dólares) - Cta. 19208571382160 - CCI 00219210857138216031</option>
              )}

              {rowValues.banco === "Interbank" && (
                <option value="MC - Cta. 2003004305580 - CCI 00320000300430558032">MC - Cta. 2003004305580 - CCI 00320000300430558032</option>
              )}

              {rowValues.banco === "Scotiabank" && (
                <option value="Yessica - Cta. 7060804239 - CCI 00931920706080423957">Yessica - Cta. 7060804239 - CCI 00931920706080423957</option>
              )}

            </select>
          </div>
        </td>
        
        {/* Pagado switch */}
        <td className=" px-6 py-4">
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              id={"igv"}
              type="checkbox"
              value={rowValues.pagado}
              disabled={data?.cotizacion?.estado === "Exito" && !isAdmin}
              checked={rowValues.pagado}
              onChange={(e) => {
                if (data?.cotizacion?.estado === "Exito" && !isAdmin) {
                  toast.warning("Solo los administradores pueden modificar pagos cuando la cotización está en estado Éxito")
                  return
                }

                setUpdatedDataText((prev) => prev + `Pagado actualizado: ${e.target.checked}.\n`)

                if (rowValues.montosServicios?.length < serviciosList?.length) {
                  toast.warning("No se puede guardar el estado del pago sin que estén los montos por servicio asignados.")
                  return
                }

                // Mostrar confirmación
                const confirmChange = window.confirm('¿Estás seguro de cambiar el estado del pago? No podrás cambiar este valor luego, además, los demás campos del pago quedarán bloqueados.');
                
                // Si el usuario confirma, cambiar el estado del checkbox
                if (confirmChange) {
                  setRowValues((prev) => ({
                    ...prev,
                    pagado: !rowValues.pagado,
                  }));
                }
              }}
              className="sr-only peer"
            />{" "}
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
          </label>
        </td>

        {/* Imagen */}
        <td className=" px-6 py-4">
          {rowValues.imagen ? (
            <div className=" relative">
              {toolTipImageActive && (
                <div
                  style={{ bottom: "110%" }}
                  className=" z-[9999] left-1/2 -translate-x-1/2 absolute  rounded-md  p-2 bg-slate-800 text-gray-50 flex justify-center gap-4"
                >
                  {rowValues.imagen.mimeType.startsWith("image/") ? (
                    <button
                      type="button"
                      onClick={() =>
                       {
                        setVerImagen({ open: true, imagen: rowValues.imagen });
                        setToolTipImageActive(false)
                       }
                      }
                      className=" bg-blue-600 hover:bg-blue-700 text-sm font-semibold text-white rounded-md p-2"
                    >
                      Visualizar
                    </button>
                  ) : (
                    <a
                      href={rowValues.imagen.url}
                      target="_blank"
                      rel={"noreferrer"}
                      className=" bg-blue-600 whitespace-nowrap hover:bg-blue-700 text-sm font-semibold text-white rounded-md p-2"
                    >
                      Ver documento
                    </a>
                  )}
                  <button
                    type="buttton"
                    onClick={() =>
                      {
                        setUploadImage({ open: true, title: "Reemplazar imagen" })
                        setToolTipImageActive(false)
                      }
                    }
                    className=" bg-gray-600 hover:bg-gray-500 text-sm font-semibold text-white rounded-md p-2"
                  >
                    Reemplazar
                  </button>
                </div>
              )}
              <div
                onClick={() => setToolTipImageActive(!toolTipImageActive)}
                className=" flex justify-center cursor-pointer p-2 rounded-md bg-green-50 text-green-600 hover:bg-green-100"
              >
                <FaRegImage className="h-6 w-6" />
              </div>
            </div>
          ) : (
            <Tooltip content={
              (() => {
                return !rowValues.pagado && (rowValues.banco === "Seleccionar" || rowValues.cuenta === "Seleccionar") 
                  ? "No se puede subir imagen sin que haya una cuenta de banco seleccionada" 
                  : "Subir imagen";
              })()
            }>
              <button
                type="button"
                disabled={!rowValues.pagado && (rowValues.banco === "Seleccionar" || rowValues.cuenta === "Seleccionar")}
                onClick={() =>
                  setUploadImage({ open: true, title: "Reemplazar imagen" })
                }
                className=" p-2 rounded-md bg-slate-50 text-slate-600 hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <MdOutlineCloudUpload className="h-6 w-6" />
              </button>
            </Tooltip>
          )}
        </td>

        {/* Pago verificado*/}
        <td className=" px-6 py-4">
          <input
            type="checkbox"
            checked={rowValues.pagoVerificado}
            onChange={(e) => {
              setUpdatedDataText((prev) => prev + `Pago verificado actualizado: ${e.target.checked}.\n`)
              setRowValues((prev) => ({
                ...prev,
                pagoVerificado: e.target.checked
              }));
            }}
            //disabled={!isAdmin}
            className="flex justify-center p-2 rounded-md bg-green-50"
          />
        </td>

        {/* Falta compromiso pago */}
        <td className=" px-6 py-4">
          <input
            type="checkbox"
            checked={rowValues.faltaCompromisoPago}
            disabled={rowValues.pagado}
            onChange={(e) => {
              setUpdatedDataText((prev) => prev + `Falta compromiso de pago actualizado: ${e.target.checked}.\n`)
              setRowValues((prev) => ({
                ...prev,
                faltaCompromisoPago: e.target.checked
              }));
            }}
            className="flex justify-center p-2 rounded-md bg-green-50"
          />
        </td>

        {/* Compra hosting */}
        {hostingDomainCot && (
          <td className=" px-6 py-4">
            <input
              type="checkbox"
              checked={rowValues.compraHosting}
              onChange={(e) => {
                setUpdatedDataText((prev) => prev + `Compra hosting actualizado: ${e.target.checked}.\n`)
                setRowValues((prev) => ({
                  ...prev,
                  compraHosting: e.target.checked
                }));
              }}
              //disabled={!isAdmin}
              className="flex justify-center p-2 rounded-md bg-green-50"
            />
          </td>
        )}

        {/* Compra hosting y dominios */}
        {hostingDomainCot && (
          <td className=" px-6 py-4">
            <input
              type="checkbox"
              checked={rowValues.compraHd}
              onChange={(e) => {
                setUpdatedDataText((prev) => prev + `Compra dominios actualizado: ${e.target.checked}.\n`)
                setRowValues((prev) => ({
                  ...prev,
                  compraHd: e.target.checked
                }));
              }}
              //disabled={!isAdmin}
              className="flex justify-center p-2 rounded-md bg-green-50"
            />
          </td>
        )}

        {/* Imagen compra dominio */}
        {hostingDomainCot && (
          <td className=" px-6 py-4">
            {rowValues.imagenCompraHd ? (
              <div className=" relative">
                {toolTipImageCompraHdActive && (
                  <div
                    style={{ bottom: "110%" }}
                    className=" z-[9999] left-1/2 -translate-x-1/2 absolute  rounded-md  p-2 bg-slate-800 text-gray-50 flex justify-center gap-4"
                  >
                    {rowValues.imagenCompraHd.mimeType.startsWith("image/") ? (
                      <button
                        type="button"
                        onClick={() =>
                        {
                          setVerImagenCompraHd({ open: true, imagen: rowValues.imagenCompraHd });
                          setToolTipImageCompraHdActive(false)
                        }
                        }
                        className=" bg-blue-600 hover:bg-blue-700 text-sm font-semibold text-white rounded-md p-2"
                      >
                        Visualizar
                      </button>
                    ) : (
                      <a
                        href={rowValues.imagenCompraHd.url}
                        target="_blank"
                        rel={"noreferrer"}
                        className=" bg-blue-600 whitespace-nowrap hover:bg-blue-700 text-sm font-semibold text-white rounded-md p-2"
                      >
                        Ver documento
                      </a>
                    )}
                    <button
                      type="buttton"
                      onClick={() =>
                        {
                          setUploadImageCompraHd({ open: true, title: "Reemplazar imagen" })
                          setToolTipImageCompraHdActive(false)
                        }
                      }
                      className=" bg-gray-600 hover:bg-gray-500 text-sm font-semibold text-white rounded-md p-2"
                    >
                      Reemplazar
                    </button>
                  </div>
                )}
                <div
                  onClick={() => setToolTipImageCompraHdActive(!toolTipImageCompraHdActive)}
                  className=" flex justify-center cursor-pointer p-2 rounded-md bg-green-50 text-green-600 hover:bg-green-100"
                >
                  <FaRegImage className="h-6 w-6" />
                </div>
              </div>
            ) : (
              <Tooltip content={
                (() => {
                  return !rowValues.pagado && (rowValues.banco === "Seleccionar" || rowValues.cuenta === "Seleccionar") 
                    ? "No se puede subir imagen sin que haya una cuenta de banco seleccionada" 
                    : "Subir imagen";
                })()
              }>
                <button
                  type="button"
                  disabled={!rowValues.pagado && (rowValues.banco === "Seleccionar" || rowValues.cuenta === "Seleccionar")}
                  onClick={() =>
                    setUploadImageCompraHd({ open: true, title: "Reemplazar imagen compra dominio" })
                  }
                  className=" p-2 rounded-md bg-slate-50 text-slate-600 hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <MdOutlineCloudUpload className="h-6 w-6" />
                </button>
              </Tooltip>
            )}
          </td>
        )}

        {/* Modal de notas*/}
        <td className=" px-6 py-4">
          <button
            onClick={() => setModalStatus(true)}
            className="flex justify-center p-2 rounded-md bg-green-50"
          >
            <FaPen className="text-green-600" />
          </button>
        </td>

      </tr>

      <SubirArchivoPagoCotizacionDialog
        setRowValues={setRowValues}
        data={data}
        onClose={() => setUploadImage((prev) => ({ ...prev, open: false }))}
        open={uploadImage.open}
        title={uploadImage.title}
        setUpdatedDataText={setUpdatedDataText}
      />

      <SubirArchivoCompraDominioDialog
        setRowValues={setRowValues}
        data={data}
        onClose={() => setUploadImageCompraHd((prev) => ({ ...prev, open: false }))}
        open={uploadImageCompraHd.open}
        title={uploadImageCompraHd.title}
        setUpdatedDataText={setUpdatedDataText}
      />

      <VerPagoCotizacionDialog
        imagen={verImagen.imagen}
        open={verImagen.open}
        onClose={() => setVerImagen((prev) => ({ ...prev, open: false }))}
      />

      <VerPagoCotizacionDialog
        imagen={verImagenCompraHd.imagen}
        open={verImagenCompraHd.open}
        onClose={() => setVerImagenCompraHd((prev) => ({ ...prev, open: false }))}
      />
    </>
  );
};

export default ItemRowPagoCotizacion;